import { MDBAlert, MDBBtnGroup, MDBCheckbox, MDBDatatable, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBIcon, MDBInput, MDBTooltip } from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from 'react'
import HandShake from "../../../components/images/handshake-trusted-trust-outline.svg"
import TrustAccountUsers from '../../popups/securitymanager/TrustAccountUsers';
import PopupLoaderNew from '../../popups/PopupLoaderNew';

function DeviceToTrustUsers(props) {
    const [updatesuccessMessage2, setUpdateSuccessMessage2] = useState("");
    const [isEditing2, setIsEditing2] = useState(false);
    const [deviceToTrust, setdeviceToTrust] = useState([]);
    const [deviceToTrustSearch, setdeviceToTrustSearch] = useState([]);
    const [selectedRecord, setselectedRecord] = useState([]);
    const [allChecked, setallChecked] = useState(false);
    const [disableMulti, setdisableMulti] = useState(true);
    const [userActionList, setUserActionList] = useState([]);
    const [searchValue, setsearchValue] = useState("");
    const [finalInfo, setfinalInfo] = useState([]);
    const [showPopup, setshowPopup] = useState(false);
    const togglePOPUp = () => setshowPopup(!showPopup);
    const [isLoading, setisLoading] = useState(false);
    const addUserRef = useRef(null);
    
        function handleClick() {
            addUserRef.current.click();
        }
    // const [actionType, setactionType] = useState(0);

    useEffect(() => {
        if (props.devicesToTrust && props.devicesToTrust.length > 0) {
            setdeviceToTrust(props.devicesToTrust);
            setdeviceToTrustSearch(props.devicesToTrust);
        }

    }, [props.devicesToTrust]);

    let processdrows = [];
    deviceToTrust.map((device) => {
        processdrows.push({
            deviceInfo: { ...device },
            checkBoxValue: (<>
                <MDBCheckbox checked={selectedRecord.includes(device?.device_id)} onClick={(e) => handleCheckedRow(e, device)} />
            </>),
            devicename: device.Device_name,
            browsername: device.browser_name,
            action: 
            // (
            //     <div className="d-flex align-items-center justify-content-center">
            //         <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip">
            //             <MDBIcon fas icon="times" color="primary"
            //                 onClick={(e) => handleAction(e, [device])}
            //                 className="mx-2 fs-5" />
            //         </div>
            //     </div>
            // ),
            (
                            <>
                                <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
                                    <img onClick={(e) => handleAction(e, [device])} src={HandShake} className="w_20px cursor-pointer" />
                                </MDBTooltip>
                            </>
                        ),

        })
    })

    const handleAllChecked = (isChecked) => {
        if (isChecked) {
            setallChecked(true);
            setselectedRecord(deviceToTrust.map(media => media.device_id));
            setUserActionList(deviceToTrust);
            setdisableMulti(false);

        } else {
            setallChecked(false);
            setselectedRecord([]);
            setUserActionList([]);
            setdisableMulti(true);
        }
    }

    const handleCheckedRow = (e, selectrow) => {
        e.preventDefault();
        console.log(JSON.stringify(selectrow));
        let updatedRecordlList = [];
        let updateSelectRecord = [];

        if (e.target.checked) {
            updatedRecordlList = [...userActionList, selectrow];
            updateSelectRecord = [...selectedRecord, selectrow.device_id]
        } else {
            updatedRecordlList = userActionList.filter((tmdata) => tmdata.device_id !== selectrow.device_id);
            updateSelectRecord = selectedRecord.filter((tmdata) => tmdata !== selectrow.device_id);
        }
        const allSelected = deviceToTrust.length > 0 ? deviceToTrust.every(row => updateSelectRecord.includes(row.device_id)) : false;
        if (allSelected) {
            setallChecked(true);
        } else {
            setallChecked(false);
        }
        if (updatedRecordlList.length > 0) {
            setdisableMulti(false);
        } else {
            setdisableMulti(true);
        }
        setUserActionList(updatedRecordlList);
        setselectedRecord(updateSelectRecord);

    }

    const handleAction = (e, info) => {
        e?.preventDefault();
        setfinalInfo([...info]);
        // setactionType(flag);
        togglePOPUp();



    }

    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUser = deviceToTrustSearch.filter((user) =>
            Object.entries(user).some(([key, value]) => {
                return value?.toString().toLowerCase().includes(searchValue.toLowerCase());
            })
        );
        setdeviceToTrust(filteredUser);
    };


    const actionData3 = {
        columns: [
            {
                label: (<>
                    <MDBCheckbox checked={allChecked} onChange={(e) => handleAllChecked(e.target.checked)} />
                </>), field: "checkBoxValue", sort: false
            },
            { label: 'Device Name', field: 'devicename' },
            { label: 'Browser Name', field: 'browsername' },
            { label: 'Action', field: 'action', sort: false },
        ],
        rows: processdrows,
        // [
        //     {
        //         ipAddress: 'Harish@pandorarndlabs.com',
        //         ipAddressRange: 'Chrome',
        //         Actions: (
        //             <>
        //                 <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
        //                     <img src={HandShake} className="w_20px cursor-pointer" />
        //                 </MDBTooltip>
        //             </>
        //         )
        //     },
        //     {
        //         ipAddress: 'Harish@pandorarndlabs.com',
        //         ipAddressRange: 'Chrome',
        //         Actions: (
        //             <>
        //                 <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
        //                     <img src={HandShake} className="w_20px cursor-pointer" />
        //                 </MDBTooltip>
        //             </>
        //         )
        //     },
        //     {
        //         ipAddress: 'Harish@pandorarndlabs.com',
        //         ipAddressRange: 'Chrome',
        //         Actions: (
        //             <>
        //                 <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
        //                     <img src={HandShake} className="w_20px cursor-pointer" />
        //                 </MDBTooltip>
        //             </>
        //         )
        //     },
        //     {
        //         ipAddress: 'Chinna@pandorarndlabs.com',
        //         ipAddressRange: "Chrome",
        //         Actions: (
        //             <>
        //                 <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
        //                     <img src={HandShake} className="w_20px cursor-pointer" />
        //                 </MDBTooltip>
        //             </>
        //         )
        //     },
        //     {
        //         ipAddress: 'Harish@pandorarndlabs.com',
        //         dateandtime: 'August-25-2022 23:00:17',
        //         Actions: (
        //             <>
        //                 <MDBTooltip tag='a' wrapperProps={{ href: '#' }} placement='left' title="Trust device for all users">
        //                     <img src={HandShake} className="w_20px cursor-pointer" />
        //                 </MDBTooltip>
        //             </>
        //         )
        //     },
        // ]
    };


    return (
        <>
            <div className="actionbar">
                <MDBBtnGroup
                    aria-label="Button group with nested dropdown"
                    className="display-inline ms-3 btn_adjust h-inherit"
                >
                    <MDBBtnGroup>
                        <MDBDropdown>
                            <MDBDropdownToggle className="px-3" disabled={disableMulti}>
                                <div className="text-white">
                                    <MDBIcon fas icon="ellipsis-v" className="me-2" />
                                    More
                                </div>
                            </MDBDropdownToggle>
                            <MDBDropdownMenu>
                                <MDBDropdownItem onClick={(e) => handleAction(e, userActionList)} link>Trust For All User(s) in Account</MDBDropdownItem>
                            </MDBDropdownMenu>
                        </MDBDropdown>
                    </MDBBtnGroup>
                </MDBBtnGroup>

            </div>

            <div className='mb-2 mt-3 position-relative w-auto'>
                <MDBInput label="Search" value={searchValue} onChange={(e) => handleManualSearch(e.target.value)} />
                <MDBIcon fas icon="search" className='MDBDatatable-Search' />
            </div>
            <div className="SecutityTopViewPage1 selectableRows">
                <MDBDatatable className='actioncolumn' hover data={actionData3} sortField="Device Name" entries={50}/>
            </div>


            {updatesuccessMessage2 && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={10000}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{updatesuccessMessage2}</span>
                </MDBAlert>
            )}

            {showPopup && (
                <PopupLoaderNew
                    title={"Trust for All Users in Account"}
                    content={<TrustAccountUsers
                        userInfoList={finalInfo}
                        onClose={togglePOPUp}
                        ref={addUserRef}
                        setIsloading={setisLoading}
                    />}
                    onShow={setshowPopup}
                    onClose={togglePOPUp}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={15}
                />
            )}

        </>
    )
}

export default DeviceToTrustUsers
